import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import HREF, { RESEARCH } from "../../db/hrefConstance"

function Direction() {
  const { id } = useParams<{ id: string }>();
  if (id && (Number(id) < 1 || Number(id) > 4)) {
    return <></>;
  }
  const activeItem = id ? Number(id) : 1;

  return (
    <React.Fragment>
      <div className="local fl">
        <h3>研究组概况</h3>
        <div className="dqwz fr">
          当前位置：
          <Link to={HREF.INDEX}>主页</Link>&gt;
          <Link to={HREF.RESEARCH}>研究组概况</Link>&gt;
          <Link to={HREF.RESEARCH_DIRECTION}>研究方向</Link>&gt;
          {
            [
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/1`}>城市计算</Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/2`}>智能交通</Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/3`}>社会计算</Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/4`}>情感计算</Link>,
            ][activeItem - 1]
          }
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.RESEARCH_DIRECTION} className="ej-current">
              研究方向
            </Link>
          </li>
          <li>
            <Link to={HREF.RESEARCH_PLATFORM}>支撑平台</Link>
          </li>
          <li>
            <Link to={HREF.RESEARCH_FOUNDATION}>已有基础</Link>
          </li>
        </ul>
      </div>
      <div className="content fl">
        <div className="Publications-title fl">
          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/1`}
                title="城市计算"
                className={activeItem === 1 ? "Publications-current" : ""}
              >
                城市计算
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/2`}
                title="智能交通"
                className={activeItem === 2 ? "Publications-current" : ""}
              >
                智能交通
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/3`}
                title="社会计算"
                className={activeItem === 3 ? "Publications-current" : ""}
              >
                社会计算
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/4`}
                title="情感计算"
                className={activeItem === 4 ? "Publications-current" : ""}
              >
                情感计算
              </Link>
            </li>
          </ul>
        </div>
        {[<Part1 />, <Part2 />, <Part3 />,<Part4 />][activeItem - 1]}
      </div>
    </React.Fragment>
  );
}

export { Direction };

function Part1() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          本研究组自成立至今，承担了大量的科研任务，积累了较为深厚的城市计算、计算社会科学、智能交通相关研究工作，有较丰富项目经验，多年来已经取得了一系列研究成果，主持了多项国家级项目，发表和出版了一系列学术论文和著作，获得多项专利授权和省部级科研奖项，在国内外具有一定的影响力。
        </p>
        <br />
        <h1 style={{ textAlign: "center" }}>
          <strong>城市计算</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          城市计算核心问题主要包括四个方面：城市感知、海量异构数据的管理、异构数据的协同计算、结合了虚拟和实际数据的混合系统在物理和虚拟世界中来回传播。
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          本研究组在以下几个方面等卓有成果:
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          1）本研究组提出以人类行为与时空轨迹数据挖掘和处理技术方面的研究为基础，较系统地综述了移动众包技术在智慧城市中的应用，从全新视角总结了MCS在智能城市中的广泛和多样化的应用，例如智能导航、智慧生活、公共服务和智慧交通(IEEE
          Internet of Things Journal 2019)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          2）本研究组提出基于浮动车数据和城市功能区的划分，构建出社会车辆出行的交通仿真场景，通过实现北京市社会车辆出行的场景验证了该方法的有效性，该方法具有很强的通用性，可适用于全世界的主要大城市(IEEE
          Transactions on Vehicular Technology 2018)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          3）本研究组提出分析浮动车数据，得到出租车乘客的轨迹信息，挖掘这些轨迹所跨越的不同城市功能区，为出租车司机推荐活动区域和轨迹，从而减少空乘率，提高收益(IEEE
          Transactions on Industrial Informatics 2017)。
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          4）本研究组通过在图卷积网络的嵌入空间上聚类，提出了一种无监督的商业区发现框架，以解决商业区发现问题。首先，所提出的框架通过图卷积网络根据地理相似性聚合人类移动特征。其次，基于图卷积网络的嵌入空间，应用层次聚类来挖掘隐藏在不同人类模式中的潜在功能区域。最后通过核密度估计，获得聚类结果的语义标签，以发现潜在的商业区。
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          5）本研究组提出了一种基于时空成本组合的出租车驾驶欺诈检测框架。首先，确定车辆与协同车联网(C-IoV)中隐性交互、协作的其他车辆和兴趣点(POI)，并构建基线轨迹模型以确定典型的轨迹分布。其次，使用统计模型计算出行分布、出行时间和出行成本以检测异常轨迹。最后我们可以结合对异常道路环境的感知来挖掘异常轨迹形成的根本成因。
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p5.png" />
        </p>
      </div>
    </div>
  );
}

function Part2() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <h1 style={{ textAlign: "center" }}>
          <strong>智能交通</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>智能交通信号灯控制：</strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          本研究组针对交通态势现状及发展趋势，分别面向拥堵区域和非拥堵区域提出了交通控制子区动态划分方法，以及子区协调路径的自动识别算法。构建了面向复杂场景的子区信号控制方案生成器，实现了基于多目标优化的方案生成和基于专家经验的方案生成。在此基础上，提出了基于方案知识库训练迭代的AI控制方法，实现了各类特定复杂场景中信号控制方案的自动优化和匹配。
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>智能交通协同管理：</strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          本研究组利用融合处理后的各类交通特征参数，建立了多源城市交通事件驱动的交通指挥调度与信号协同管控模型。在指挥调度模型框架内，采用AI视频全域感知识别技术、事件预判分析技术、实时调度优化技术进行城市事件综合指挥与协同管理。针对特种车辆的城市特种任务需求，研究路径规划诱导技术、轨迹追踪预测技术、信号协同优化技术和全局规划调度技术，保障应急车辆快速顺畅通行。
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/2020Emergency.png" />
        </p>
      </div>
    </div>
  );
}

function Part3() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <h1 style={{ textAlign: "center" }}>
          <strong>社会计算</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>
            社会数据，信号和智能向社会智慧的转化和量化是社会计算的核心目标。
          </strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          1）本研究组提出一种基于会议闭包的可持续合作者推荐方法，通过学者参会认识的新合作者概率，提出量化学术会议对学术合作的具体方法，通过引入会议闭包关系和合作强度，构建加权的学术合作网络，利用重启型随机游走算法，计算目标学者和其他学者的相似度，进而对目标学者进行合作者推荐(IEEE
          Transactions on Computational Social Science 2019)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          2）本研究组提出融合文本和结构的基于网络表示学习的论文推荐方法：首先将论文的文本信息通过文本向量表示生成论文文本向量用以找到具有相似研究内容的论文，接着将引用网络中隐藏的结构特征转化为向量并找到具有相似网络拓扑结构的论文，将文本相似论文和结构相似论文与目标论文连接重构引用网络，然后通过网络表示学习得到论文的矢量表示，最后根据论文向量之间的相似度生成推荐列表(IEEE
          Transactions on Emerging Topics in Computing 2018)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          3）本研究组提出一种基于学术年龄的学术合作动态演化分析方法，能够更全面的揭示学术合作机制，帮助政策制定者制定新的政策，以促进不同学术年龄的学者之间的合作，特别是帮助青年学者更快的融入学术社会(Scientometrics
          2017)。
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          4）本研究组提出了新颖的大学分析框架(UPF)，该框架包含一个个新颖的循环深度聚类模型（Recurrent-DC），用于学习深度表征和聚类；在该框架中，聚类算法中的连续操作表示为循环过程中的步骤，堆叠在堆叠自动编码器 (SAE) 输出的表示之上。该框架可以很好的进行大学学科分析。（Future Generation Computer Systems）
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          5）本研究组提出了一种基于边缘计算的口罩识别框架(ECMask)，该框架包含三个主要阶段：视频恢复、人脸检测和口罩识别，该框架可以很好的检测出行人是否戴口罩，可以很好的帮助预防公共流行病，如COVID-19。（IEEE Internet of Things Journal）
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          6）本研究组提出了一种基于异构移动众包的公交分析方案，该方案设计了一个基于MCS的公交数据生成和收集方法以克服数据稀缺的问题，同时我们提出了多约束进化算法来优化用户的旅行路线。该方案可以很好的满足旅客的出行需求（ IEEE Transactions on Industrial Informatics）
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          7）本研究组提出了一种基于联邦学习的车牌识别框架（FedLPR），此外，本研究组还提出了一种倾斜车牌校正算法以提高车牌字符识别的准确性，该框架可以在保护用户隐私的同时具有较高的车牌识别准确率，并且其通信成本是可接受的。(EEE Transactions on Industrial Informatics)
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          8）本研究组提出了一种基于联邦学习（FedVCP）的车辆协同定位（CP）系统，该系统利用迁移学习来消除车辆定位的个体差异，并且利用联邦学习解决CP隐私问题。该系统能充分利用社交物联网（IoT）和协同边缘计算（CEC）的潜力，在提供高精准定位校正的同时保证用户隐私。（EEE Transactions on Computational Social Systems）
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p17.png" />
        </p>
      </div>
    </div>
  );
}

function Part4() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <h1 style={{ textAlign: "center" }}>
          <strong>情感计算</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>
          情感计算旨在通过赋予计算机识别、理解和表达人的情感的能力，使得计算机具有更高的智能。
          </strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        1）细粒度文本情感分析：本研究组提出一种多尺度融合文本跨度特征的评价三元组抽取方法。
        利用不同卷积核大小的卷积神经网络提取不同跨度下的局部特征。
        并设计了一个简单的跨度感知表示选择机制用于更好的获取跨度表示，从而更好地抽取评论中的评价三元组（评价对象、评价词、情感极性）。
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p18.png" />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        2）房地产领域用户画像：针对房地产企业传统宣传方式存在的投资力度大但效果不明显的问题，
        本研究组提出一种基于信息提取和多属性支持决策的房地产买家画像建模方法。
        通过抽取非结构化文本中的关键短语以及匹配人工构造的模版，
        实现真实场景下非结构化数据到结构化数据的转变。
        采用专家知识和基于熵的权重分配算法来计算不同属性相对不同特征的重要程度，
        构造特定房地产买家的特征表示，从而充分挖掘房地产买家之间隐含的异质关系，
        最终实现房地产买家画像的建模，有效地帮助房地产企业进行精准营销。
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p19.png" />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        3）文本生成：由于语料库的稀缺以及人工标记的难度大，文本生成可以很好的解决这个问题。
        </p>
      </div>
    </div>
  );
}
